import { render, staticRenderFns } from "./BodyStageStepperCongratulations.vue?vue&type=template&id=efc7b298&scoped=true&"
import script from "./BodyStageStepperCongratulations.vue?vue&type=script&lang=js&"
export * from "./BodyStageStepperCongratulations.vue?vue&type=script&lang=js&"
import style0 from "./BodyStageStepperCongratulations.vue?vue&type=style&index=0&id=efc7b298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc7b298",
  null
  
)

export default component.exports